import React from "react";
import cx from "classnames";
import { Dropdown } from "react-bootstrap";
import styles from "./filterDropdown.module.scss";

interface Option {
  value: string;
  label: string;
  icon?: string;
}

interface FilterDropdownProps {
  selected: Option;
  options: Option[];
  onChange: (option: Option) => void;
}

export const FilterDropdown: React.FC<FilterDropdownProps> = ({
  selected,
  options,
  onChange,
}) => {
  const [show, setShow] = React.useState(false);
  const [atBottom, setAtBottom] = React.useState(false);
  const menuRef = React.useRef<HTMLElement | null>(null);

  const selectedOption = React.useMemo(
    () => options.find((o) => o.value === selected.value),
    [selected, options],
  );

  const handleSelect = (option: Option) => {
    onChange(option);
  };

  const checkAtBottom = () => {
    const el = menuRef.current;
    if (!el) return;
    setAtBottom(el.scrollHeight - el.scrollTop - el.clientHeight < 1);
  };

  React.useEffect(() => {
    if (show) checkAtBottom();
  }, [show]);

  return (
    <Dropdown className={styles.dropdown} onToggle={(isOpen) => setShow(isOpen)}>
      <Dropdown.Toggle className={styles.toggle}>
        {selectedOption?.label}
        {options.length > 1 && (
          <i
            className={cx("paperflite-dropdown", styles.chevron, {
              [styles.open]: show,
            })}
          />
        )}
      </Dropdown.Toggle>
      {options.length > 1 && (
        <Dropdown.Menu
          ref={menuRef as React.Ref<HTMLDivElement>}
          className={styles.menu}
          onScroll={checkAtBottom}
          popperConfig={{
            modifiers: [{ name: "offset", options: { offset: [0, 6] } }],
          }}
        >
          <div className={styles.menuScroll}>
            {options.map((option) => (
              <Dropdown.Item
                key={option.value}
                className={cx(styles.item, {
                  [styles.active]: option.value === selectedOption?.value,
                })}
                onClick={() => {
                  handleSelect(option);
                }}
              >
                <span>{option.label}</span>
              </Dropdown.Item>
            ))}
          </div>
          <div
            className={cx(styles.bottomFade, { [styles.fadeHidden]: atBottom })}
            aria-hidden
          />
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};
